module.exports = __webpack_public_path__ + "static/devoxxfr-763c5e91480bbde4732448809b5cfc28.png";